import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function SideBar() {
  const { pathname } = useLocation();
  const hostname = window.location.hostname;

  const [menu, setMenu] = useState(
    () =>
      localStorage.getItem("myMenu") ||
      "light-style layout-navbar-fixed layout-compact layout-menu-fixed",
  );

  const [toggle, setToggle] = useState(
    () => localStorage.getItem("myToggle") === "true",
  );

  const setting = JSON.parse(localStorage.getItem("setting") ?? "{}");
  const client = JSON.parse(localStorage.getItem("client") ?? "{}");

  useEffect(() => {
    document.documentElement.className = menu;
    localStorage.setItem("myMenu", menu);
    localStorage.setItem("myToggle", String(toggle));
  }, [menu, toggle]);

  const baseMenu =
    "light-style layout-navbar-fixed layout-compact layout-menu-fixed";

  const changeMenuOnHover = () => {
    setMenu(
      toggle ? `${baseMenu} layout-menu-collapsed layout-menu-hover` : baseMenu,
    );
  };

  const changeMenuOffHover = () => {
    setMenu(toggle ? `${baseMenu} layout-menu-collapsed` : baseMenu);
  };

  const changeMenuOnClick = () => {
    setToggle((t) => !t);

    setMenu((prev) =>
      prev.includes("layout-menu-collapsed")
        ? baseMenu
        : `${baseMenu} layout-menu-collapsed`,
    );
  };

  const menuCategories = useMemo(
    () => [
      {
        title: "Main",
        items: [
          {
            label: "Dashboard",
            path: "/admin/dashboard",
            icon: "ri-home-4-line",
            active: ["/admin/dashboard"],
          },
        ],
      },

      {
        title: "Student",
        items: [
          {
            label: "Student Report",
            path: "/admin/student/report",
            icon: "ri-user-search-line",
            active: [
              "/admin/student/report",
            ],
          },
        ]
      },
      {
        title: "Branches",
        items: [
          {
            label: "Branches",
            path: "/admin/branch/list",
            icon: "ri-question-line",
            active: [
              "/admin/branch/list"
            ],
          },
        ]
      },
      {
        title: "Finance",
        items: [
          {
            label: "Fees & Collection",
            path: "/admin/finance/report",
            icon: "ri-money-rupee-circle-line",
            active: [
              "/admin/finance/report"
            ],
          },
        ]
      }
    ],
    [pathname, setting, client],
  );

  let logo;

  if (hostname.includes("tifa.arjtech.xyz")) {
    logo = "/files/tifa_logo.png";
  } else {
    logo = "/files/logo.png";
  }

  return (
    <aside
      id="layout-menu"
      className="layout-menu menu-vertical menu bg-menu-theme hide-scrollbar"
      onMouseOver={changeMenuOnHover}
      onMouseOut={changeMenuOffHover}
      style={{
        boxShadow: "0px 0px 10px 2px #979797",
      }}
    >
      <div className="app-brand">
        <Link to="/" className="app-brand-link">
          <span className="app-brand-logo me-1" style={{ height: "60px" }}>
            <img src={logo} height="100%" alt="Logo" />
          </span>
        </Link>

        <span className="layout-menu-toggle menu-link text-large ms-auto hover-pointer">
          <i
            className="menu-toggle-icon d-xl-block align-middle"
            onClick={changeMenuOnClick}
          ></i>
        </span>
      </div>

      <ul
        className="menu-inner"
        style={{
          maxHeight: "90vh",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {menuCategories.map((category, index) => {
          const visibleItems = category.items;

          if (visibleItems.length === 0) return null;

          return (
            <React.Fragment key={index}>
              <li className="menu-header small text-uppercase">
                <span className="menu-header-text">{category.title}</span>
              </li>

              {visibleItems?.map((item, idx) => (
                <li
                  key={idx}
                  className={`menu-item ${item.active.includes(pathname) ? "active" : ""
                    }`}
                >
                  <Link
                    to={item.path}
                    className={`menu-link ${item.className || ""}`}
                    target={item.target || "_self"}
                  >
                    <i className={`menu-icon tf-icons ${item.icon}`}></i>

                    <div>{item.label}</div>
                  </Link>
                </li>
              ))}
            </React.Fragment>
          );
        })}
      </ul>
      <div className="app-brand py-1">
        <Link to="/" className="app-brand-link ri-14px fw-bold">
          Developed By ARJ Technologies
        </Link>

        <span className="layout-menu-toggle menu-link text-large ms-auto hover-pointer">
          <i
            className="ri-sidebar-fold-line hover-pointer"
            onClick={changeMenuOnClick}
          ></i>
        </span>
      </div>
    </aside>
  );
}
